<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IMa6ZF/tc-custom/9780802196859.jpg?1702083978108" alt="This image is the cover for the book Primitive Heart"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Primitive Heart
      </h1>
      <p class="bookDescription body article font2">
        <b>Tales from the Tony Award–winning playwright: “Not only an exhibition of David Rabe’s acclaimed dramatic powers but also proof of his narrative magic” (Billy Collins, former US Poet Laureate).</b><br/>  <br/> David Rabe, playwright of <i>Hurlyburly</i> and <i>In the Boom Boom Room</i>, brings his intense vision to the world of fiction with a short story collection of astonishing range and versatility. Whether he is writing about a marriage shadowed by the unacknowledged discord of a risky pregnancy, a group of men whose attempt to settle an account launches them toward unexpected violence, or a young journalist who believes he’s escaped his Catholic roots only to be forced again to confront them by a priest who once mentored his writing, Rabe’s strong, true voice tenders an inimitable portrait of America and offers benediction to her lost souls. <i>A Primitive Heart</i> confirms the mastery of a writer and establishes David Rabe as an exciting voice in fiction.<br/>  <br/> “Rabe has a way of implicating the reader—of creating a near-claustrophobic bond with his restless characters, writing so convincingly that the subtext becomes almost palpable, accruing darkly, like a storm. Okay: I’m eating my heart out.” —Ann Beattie, PEN/Malamud Award–winner<br/>  <br/> “These are gripping stories, hard to put aside, that cut so close to primitive emotional truths that they can be painful to read . . . That vivid confusion—the desire to understand something more primitive than thought—makes these stories unforgettable.” —<i>The Seattle Times</i><br/>  <br/> “David Rabe demonstrates in this new collection of short stories that his talent for dialogue is just as dazzling inside a prose narrative as it is on stage.” —<i>The Baltimore Sun</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Rabe
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bbae26a2